import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { SimpleRouterState } from '@platform-frontend/util';
import { DisabledDetailsState } from './disabled-details.state';
import { DisabledReason } from './model/disabled-reason';

export const DisabledReasonGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(Store);
  if (store.selectSnapshot(SimpleRouterState.guardsActivated)) {
    const disabledReason: DisabledReason | null = route.data.disabledReason ?? null;
    return store.selectSnapshot(DisabledDetailsState.reason) === disabledReason;
  } else {
    return true;
  }
};
